import React from 'react';

interface QuickFactsProps {
  stats: {
    total_generated_kwh: number;
    co2_saved_tonnes: string;
  };
}

const QuickFacts: React.FC<QuickFactsProps> = ({ stats }) => {
  // Calculate trees planted equivalent
  // Average tree absorbs about 21 kg of CO2 per year
  // 1 tonne = 1000 kg, so 1 tonne = ~48 trees per year
  const co2Tonnes = parseFloat(stats.co2_saved_tonnes);
  const treesEquivalent = Math.round(co2Tonnes * 48);

  return (
    <div>
      <h2 className="text-lg sm:text-xl font-medium font-sans mb-4 text-center">Quick Facts</h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
        <div className="text-center">
          <p className="text-sm text-gray-600 mb-1">Generated:</p>
          <p className="text-2xl font-medium font-sans">{stats.total_generated_kwh.toLocaleString()} kWh</p>
        </div>
        <div className="text-center">
          <p className="text-sm text-gray-600 mb-1">CO₂ Saved:</p>
          <p className="text-2xl font-medium font-sans">{stats.co2_saved_tonnes}t</p>
        </div>
        <div className="text-center">
          <p className="text-sm text-gray-600 mb-1">Trees Planted:</p>
          <div className="flex items-center justify-center">
            <svg className="w-6 h-6 text-green-600 mr-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2l-2 4h-3l3 4h-4l5 6v6h2v-6l5-6h-4l3-4h-3l-2-4z"/>
            </svg>
            <p className="text-2xl font-medium font-sans">{treesEquivalent.toLocaleString()}</p>
          </div>
          <p className="text-xs text-gray-500 mt-1">equivalent</p>
        </div>
      </div>
      <div className="mt-4 text-center text-sm text-gray-600">
        Your CO₂ Savings = {treesEquivalent.toLocaleString()} trees planted!
      </div>
    </div>
  );
};

export default QuickFacts;